/* eslint-disable */
/* eslint-disable no-restricted-globals, no-undef */
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Textarea,
  Text,
  VStack,
  HStack,
  Heading,
  Card,
  CardBody,
  IconButton,
  Badge,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Select,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Icon,
  Switch,
  CheckboxGroup,
  Checkbox,
  Stack,
} from "@chakra-ui/react";
import { FaPlayCircle, FaFilePdf, FaBrain, FaEye, FaEyeSlash } from "react-icons/fa";
import React, { useState, useEffect } from "react";
import { DEPARTMENTS } from "../../constants/departments";
import { ArrowUpIcon, ArrowDownIcon, DeleteIcon, EditIcon, AddIcon } from "@chakra-ui/icons";
import "../Adminitems/edit.css";
import TeacherNavTop from "./TeacherNavTop";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { patchProduct, getProduct } from "../../Redux/TeacherReducer/action";
import axios from "axios";
import { useModalToast } from "../../context/GlobalModalToast";

const EditPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const store = useSelector((store) => store.TeacherReducer.data) || [];
  const navigate = useNavigate();
  const { toast, confirm } = useModalToast();

  const existedUser = Array.isArray(store) ? store.filter((el) => el && el?._id == id) : [];

  let obj = {
    title: existedUser[0]?.title || "",
    description: existedUser[0]?.description || "",
    category: existedUser[0]?.category || "",
    department: existedUser[0]?.department || "",
    teacher: existedUser[0]?.teacher || "",
    isDisabled: existedUser[0]?.isDisabled || false,
    isGlobal: existedUser[0]?.isGlobal !== undefined ? existedUser[0]?.isGlobal : true,
    targetSectors: existedUser[0]?.targetSectors || [],
    img: existedUser[0]?.img || existedUser[0]?.thumbnail || "",
    allowComments: existedUser[0]?.allowComments !== undefined ? existedUser[0]?.allowComments : true
  };

  const [detail, setDetail] = useState(obj);
  const [sections, setSections] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  // Modal State for Editing / Adding Sections
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editingIndex, setEditingIndex] = useState(-1); // -1 means adding new
  const [sectionForm, setSectionForm] = useState({
    title: "",
    type: "video",
    content: "",
    transcript: "",
    isVideoUpload: false});
  const [isUploading, setIsUploading] = useState(false);

  // Fetch course details, sections, and categories on mount
  useEffect(() => {
    const fetchCourseData = async () => {
      setIsLoading(true);
      try {
        const token = JSON.parse(localStorage.getItem("user"))?.token || "";
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/courses/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        setDetail({
          title: res.data.title || "",
          description: res.data.description || "",
          category: res.data.category || "",
          department: res.data.department || "",
          teacher: res.data.teacher || "",
          isDisabled: res.data.isDisabled || false,
          isGlobal: res.data.isGlobal !== undefined ? res.data.isGlobal : true,
          targetSectors: res.data.targetSectors || [],
          img: res.data.img || res.data.thumbnail || "",
          allowComments: res.data.allowComments !== undefined ? res.data.allowComments : true
        });
        setSections(res.data.sections || []);
      } catch (err) {
        console.error(err);
        toast({ title: "Failed to load course details", status: "error", duration: 3000 });
      } finally {
        setIsLoading(false);
      }
    };

    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories`);
        setCategories(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCourseData();
    fetchCategories();
  }, [id, toast]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetail((prev) => ({ ...prev, [name]: value }));
  };

  const handleSectionFormChange = (e) => {
    const { name, value } = e.target;
    setSectionForm((prev) => ({ ...prev, [name]: value }));
  };

  // Upload handler for replacement video/PDFs
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    setIsUploading(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" }});
      
      const fileName = file.name.toLowerCase();
      const isPdf = file.type === 'application/pdf' || fileName.endsWith('.pdf');
      const isVideo = file.type.startsWith('video/');

      setSectionForm((prev) => ({
        ...prev,
        content: res.data.url,
        transcript: res.data.transcript || prev.transcript || "",
        type: isPdf ? 'documentation' : (isVideo ? 'video' : prev.type),
        isVideoUpload: isVideo,
        minWatchTime: isVideo && res.data.duration ? Math.floor(res.data.duration * 0.70) : (prev.minWatchTime || 0)
      }));
      toast({ title: "File uploaded successfully!", status: "success", duration: 3000 });
    } catch (err) {
      console.error(err);
      toast({ title: "Upload failed. Please try again.", status: "error", duration: 3000 });
    } finally {
      setIsUploading(false);
    }
  };

  // Section CRUD Actions
  const openEditSection = (index) => {
    setEditingIndex(index);
    if (index >= 0) {
      setSectionForm({ ...sections[index] });
    } else {
      setSectionForm({
        title: "",
        type: "video",
        content: "",
        transcript: "",
        isVideoUpload: false});
    }
    onOpen();
  };

  const saveSection = () => {
    if (!sectionForm.title.trim() || !sectionForm.content.trim()) {
      toast({ title: "Please fill all fields", status: "warning", duration: 3000 });
      return;
    }

    // Check for duplicate module name
    const isDuplicate = sections.some((sec, idx) => 
      sec.title.toLowerCase() === sectionForm.title.toLowerCase() && idx !== editingIndex
    );
    if (isDuplicate) {
      toast({ title: "Module with this name already exists in this course", status: "error", duration: 3000 });
      return;
    }

    const updatedForm = { ...sectionForm };
    const contentLower = updatedForm.content.toLowerCase();
    
    // Auto-detect file types based on URL if not already set by upload handler
    if (!updatedForm.isVideoUpload && updatedForm.type !== 'documentation') {
      if (contentLower.endsWith('.pdf') || contentLower.includes('.pdf?') || updatedForm.content.includes('/api/uploads/pdf')) {
        updatedForm.type = 'documentation';
        updatedForm.isVideoUpload = false;
      } else if (updatedForm.content.includes('/api/uploads/') || updatedForm.content.includes('res.cloudinary.com/')) {
        // If it's a Cloudinary link or local upload and not a PDF, assume video upload
        if (!contentLower.endsWith('.jpg') && !contentLower.endsWith('.png')) {
           updatedForm.type = 'video';
           updatedForm.isVideoUpload = true;
        }
      } else if (updatedForm.type === 'video') {
        updatedForm.isVideoUpload = false; // YouTube embed
      }
    }

    const updatedSections = [...sections];
    if (editingIndex >= 0) {
      updatedSections[editingIndex] = updatedForm;
      toast({ title: "Module updated in list", status: "info", duration: 2000 });
    } else {
      updatedSections.push(updatedForm);
      toast({ title: "New module added to list", status: "success", duration: 2000 });
    }

    setSections(updatedSections);
    onClose();
  };

  const deleteSection = async (index) => {
    const _c = await confirm({ title: "Confirm", description: "Are you sure you want to delete this module from the course?", status: "warning" }); 
    if (_c) {
      const updated = sections.filter((_, idx) => idx !== index);
      setSections(updated);
      toast({ title: "Module removed", status: "warning", duration: 2000 });
    }
  };

  const moveUp = (index) => {
    if (index === 0) return;
    const updated = [...sections];
    const temp = updated[index];
    updated[index] = updated[index - 1];
    updated[index - 1] = temp;
    setSections(updated);
  };

  const moveDown = (index) => {
    if (index === sections.length - 1) return;
    const updated = [...sections];
    const temp = updated[index];
    updated[index] = updated[index + 1];
    updated[index + 1] = temp;
    setSections(updated);
  };

  const toggleSectionDisabled = (index) => {
    const updated = [...sections];
    updated[index] = { ...updated[index], isDisabled: !updated[index].isDisabled };
    setSections(updated);
  };

  const handleGenerateFinalQuiz = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.token;
      toast({ title: "Generating AI Quiz...", description: "Analyzing course material. This may take a minute.", status: "info", duration: 5000 });
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/courses/${id}/generate-full-quiz`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast({ title: "Success", description: "Final quiz generated and appended!", status: "success", duration: 3000 });
      if (res.data && res.data.course && res.data.course.sections) {
        setSections(res.data.course.sections);
      }
    } catch (err) {
      toast({ title: "Failed to generate quiz", description: err.response?.data?.message || err.message, status: "error", duration: 3000 });
    }
  };


  const handleSubmit = () => {
    if (!detail.title.trim()) {
      toast({ title: "Title is required", status: "error", duration: 3000 });
      return;
    }

    const payload = {
      ...detail,
      sections: sections};

    dispatch(patchProduct(id, payload));
    toast({ title: "Course saved successfully!", status: "success", duration: 3000 });
    setTimeout(() => {
      navigate("/Teacher/courses");
    }, 1000);
  };

  if (isLoading) {
    return (
      <Flex h="100vh" align="center" justify="center">
        <Spinner size="xl" color="purple.500" thickness="4px" />
      </Flex>
    );
  }

  return (
    <Box minH="100vh" bg="gray.50" pb={10}>
      <TeacherNavTop />
      
      <Box maxW="1200px" mx="auto" px={6} pt="100px">
        <Heading size="lg" mb={6} color="purple.800" fontWeight="800">
          ⚙️ Edit Corporate Course Settings
        </Heading>

        <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={8} alignItems="start">
          {/* Metadata Card */}
          <Card borderRadius="2xl" border="1px solid" borderColor="gray.200" boxShadow="sm">
            <CardBody p={6}>
              <Heading size="sm" mb={4} color="gray.700">Course Metadata</Heading>
              
              <VStack spacing={4} align="stretch">
                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Course Title</FormLabel>
                  <Input
                    type="text"
                    name="title"
                    value={detail.title}
                    onChange={handleChange}
                    placeholder="Enter Course Title"
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Course Description</FormLabel>
                  <Textarea
                    name="description"
                    value={detail.description}
                    onChange={handleChange}
                    placeholder="Enter course details, key learning goals..."
                    rows={4}
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Category</FormLabel>
                  <Select
                    placeholder="Select Category"
                    name="category"
                    value={detail.category}
                    onChange={handleChange}
                  >
                    {categories.map((cat) => (
                      <option key={cat._id} value={cat.name}>{cat.name}</option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Department</FormLabel>
                  <Select
                    placeholder="Select Department"
                    name="department"
                    value={detail.department}
                    onChange={handleChange}
                  >
                    {DEPARTMENTS.map((dept) => (
                      <option key={dept} value={dept}>{dept}</option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl display="flex" alignItems="center">
                  <FormLabel mb="0" fontSize="sm" fontWeight="bold">Global Training Module (Available to all departments)?</FormLabel>
                  <Switch
                    isChecked={detail.isGlobal}
                    onChange={(e) => setDetail(prev => ({ ...prev, isGlobal: e.target.checked }))}
                    colorScheme="purple"
                  />
                </FormControl>

                {!detail.isGlobal && (
                  <FormControl>
                    <FormLabel fontSize="sm" fontWeight="bold">Select Target Departments</FormLabel>
                    <CheckboxGroup
                      colorScheme="purple"
                      value={detail.targetSectors}
                      onChange={(values) => setDetail(prev => ({ ...prev, targetSectors: values }))}
                    >
                      <Stack spacing={2} direction="row" wrap="wrap">
                        {DEPARTMENTS.map((dept) => (
                          <Checkbox key={dept} value={dept}>{dept}</Checkbox>
                        ))}
                      </Stack>
                    </CheckboxGroup>
                  </FormControl>
                )}

                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Instructor Name</FormLabel>
                  <Input
                    type="text"
                    name="teacher"
                    value={detail.teacher}
                    onChange={handleChange}
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="sm" fontWeight="bold">Course Thumbnail Image URL</FormLabel>
                  <Input
                    type="text"
                    name="img"
                    value={detail.img}
                    onChange={handleChange}
                    placeholder="Paste image URL here"
                  />
                </FormControl>

                <FormControl display="flex" alignItems="center" bg="red.50" p={3} borderRadius="lg" border="1px solid" borderColor="red.100">
                  <FormLabel mb="0" fontSize="sm" fontWeight="bold" color="red.700" flex="1">
                    Disable Course (Hide from all users)
                  </FormLabel>
                  <Switch
                    colorScheme="red"
                    isChecked={detail.isDisabled}
                    onChange={(e) => setDetail(prev => ({ ...prev, isDisabled: e.target.checked }))}
                  />
                </FormControl>

                <FormControl display="flex" alignItems="center">
                  <FormLabel mb="0" fontSize="sm" fontWeight="bold" flex="1">
                    Enable Discussion & Comments?
                  </FormLabel>
                  <Switch
                    colorScheme="purple"
                    isChecked={detail.allowComments}
                    onChange={(e) => setDetail(prev => ({ ...prev, allowComments: e.target.checked }))}
                  />
                </FormControl>
              </VStack>
            </CardBody>
          </Card>

          {/* Curriculum / Content Management Card */}
          <Card borderRadius="2xl" border="1px solid" borderColor="gray.200" boxShadow="sm">
            <CardBody p={6}>
              <Flex justify="space-between" align="center" mb={4}>
                <Box>
                  <Heading size="sm" color="gray.700">Curriculum & Modules</Heading>
                  <Text fontSize="xs" color="gray.500" mt={1}>Reorder, replace, or delete lesson materials</Text>
                </Box>
                <HStack spacing={2}>
                  <Button 
                    size="sm" 
                    colorScheme="teal" 
                    variant="outline"
                    borderRadius="full"
                    onClick={handleGenerateFinalQuiz}
                  >
                    ✨ Generate AI Quiz
                  </Button>
                  <Button 
                    size="sm" 
                    colorScheme="purple" 
                    leftIcon={<AddIcon />} 
                    borderRadius="full"
                    onClick={() => openEditSection(-1)}
                  >
                    Add Module
                  </Button>
                </HStack>
              </Flex>

              {sections.length === 0 ? (
                <Box py={10} textAlign="center" border="2px dashed" borderColor="gray.200" borderRadius="xl">
                  <Text color="gray.400" fontSize="sm" fontWeight="semibold">No videos or PDF files uploaded yet.</Text>
                  <Button size="xs" mt={2} colorScheme="purple" onClick={() => openEditSection(-1)}>
                    Upload First File
                  </Button>
                </Box>
              ) : (
                <Box overflowX="auto">
                  <Table size="sm" variant="simple">
                    <Thead>
                      <Tr>
                        <Th width="70px">Order</Th>
                        <Th>Title</Th>
                        <Th>Type</Th>
                        <Th textAlign="right">Actions</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {sections.map((sec, idx) => (
                        <Tr key={idx} _hover={{ bg: "purple.50" }} transition="background 0.2s">
                          <Td>
                            <HStack spacing={1}>
                              <IconButton
                                size="xs"
                                icon={<ArrowUpIcon />}
                                isDisabled={idx === 0}
                                onClick={() => moveUp(idx)}
                                aria-label="Move Up"
                              />
                              <IconButton
                                size="xs"
                                icon={<ArrowDownIcon />}
                                isDisabled={idx === sections.length - 1}
                                onClick={() => moveDown(idx)}
                                aria-label="Move Down"
                              />
                            </HStack>
                          </Td>
                          <Td fontWeight="bold" maxW="200px" isTruncated>
                            {sec.title}
                          </Td>
                          <Td>
                            <Badge colorScheme={sec.type === "video" ? "blue" : sec.type === "quiz" ? "purple" : "orange"} borderRadius="full" fontSize="10px" mr={2}>
                              {sec.type === "video" ? (sec.isVideoUpload ? "📤 Uploaded" : "🔗 YouTube") : sec.type === "quiz" ? "📝 Quiz" : "📄 PDF"}
                            </Badge>
                            {sec.isDisabled && (
                              <Badge colorScheme="red" borderRadius="full" fontSize="10px">
                                🛑 DISABLED
                              </Badge>
                            )}
                          </Td>
                          <Td textAlign="right">
                            <HStack spacing={1} justify="flex-end">
                              <IconButton
                                size="xs"
                                colorScheme={sec.isDisabled ? "green" : "gray"}
                                icon={sec.isDisabled ? <FaEye /> : <FaEyeSlash />}
                                onClick={() => toggleSectionDisabled(idx)}
                                aria-label="Toggle Section Visibility"
                                title={sec.isDisabled ? "Enable Module" : "Disable Module"}
                              />
                              <IconButton
                                size="xs"
                                colorScheme="blue"
                                icon={<EditIcon />}
                                onClick={() => openEditSection(idx)}
                                aria-label="Edit/Replace Section"
                              />
                              <IconButton
                                size="xs"
                                colorScheme="red"
                                icon={<DeleteIcon />}
                                onClick={() => deleteSection(idx)}
                                aria-label="Delete Section"
                              />
                            </HStack>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Box>
              )}
            </CardBody>
          </Card>
        </Grid>

        <Button
          mt={8}
          colorScheme="purple"
          size="lg"
          w="full"
          borderRadius="xl"
          onClick={handleSubmit}
          boxShadow="lg"
          fontWeight="bold"
        >
          Save All Changes
        </Button>
      </Box>

      {/* Edit Section Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl" motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(10px)" bg="blackAlpha.300" />
        <ModalContent borderRadius="3xl" overflow="hidden" boxShadow="2xl" border="1px solid" borderColor="whiteAlpha.500">
          <ModalHeader 
            bgGradient="linear(to-r, purple.600, blue.500)" 
            color="white" 
            pb={6}
            boxShadow="sm"
          >
            <Flex align="center" gap={3}>
              <Icon as={editingIndex >= 0 ? EditIcon : AddIcon} w={5} h={5} />
              <Text>{editingIndex >= 0 ? "📝 Replace / Edit Lesson Module" : "📤 Add Content Module"}</Text>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" mt={1} />
          
          <ModalBody pt={6} pb={8} px={8}>
            <VStack spacing={6} align="stretch">
              <FormControl isRequired>
                <FormLabel fontSize="sm" fontWeight="bold" color="gray.700">Module Title</FormLabel>
                <Input
                  type="text"
                  name="title"
                  size="lg"
                  borderRadius="xl"
                  value={sectionForm.title}
                  onChange={handleSectionFormChange}
                  placeholder="e.g. Introduction to Financial modeling"
                  _focus={{ borderColor: "purple.500", boxShadow: "0 0 0 1px purple.500" }}
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel fontSize="sm" fontWeight="bold" color="gray.700">Select Module Type</FormLabel>
                <Grid templateColumns="repeat(3, 1fr)" gap={4}>
                  <Box 
                    as="button" p={4} borderRadius="xl" border="2px solid" 
                    borderColor={sectionForm.type === 'video' ? 'purple.500' : 'gray.100'} 
                    bg={sectionForm.type === 'video' ? 'purple.50' : 'white'}
                    _hover={{ borderColor: 'purple.300', bg: 'purple.50', transform: 'translateY(-2px)' }}
                    transition="all 0.2s"
                    onClick={() => setSectionForm(prev => ({ ...prev, type: 'video', isVideoUpload: false, content: "", transcript: "" }))}
                  >
                    <VStack spacing={2}>
                      <Icon as={FaPlayCircle} w={6} h={6} color={sectionForm.type === 'video' ? 'purple.600' : 'gray.400'} />
                      <Text fontSize="sm" fontWeight="bold" color={sectionForm.type === 'video' ? 'purple.800' : 'gray.600'}>Video Lesson</Text>
                    </VStack>
                  </Box>
                  <Box 
                    as="button" p={4} borderRadius="xl" border="2px solid" 
                    borderColor={sectionForm.type === 'documentation' ? 'purple.500' : 'gray.100'} 
                    bg={sectionForm.type === 'documentation' ? 'purple.50' : 'white'}
                    _hover={{ borderColor: 'purple.300', bg: 'purple.50', transform: 'translateY(-2px)' }}
                    transition="all 0.2s"
                    onClick={() => setSectionForm(prev => ({ ...prev, type: 'documentation', isVideoUpload: false, content: "", transcript: "" }))}
                  >
                    <VStack spacing={2}>
                      <Icon as={FaFilePdf} w={6} h={6} color={sectionForm.type === 'documentation' ? 'purple.600' : 'gray.400'} />
                      <Text fontSize="sm" fontWeight="bold" color={sectionForm.type === 'documentation' ? 'purple.800' : 'gray.600'}>PDF Document</Text>
                    </VStack>
                  </Box>
                  <Box 
                    as="button" p={4} borderRadius="xl" border="2px solid" 
                    borderColor={sectionForm.type === 'quiz' ? 'purple.500' : 'gray.100'} 
                    bg={sectionForm.type === 'quiz' ? 'purple.50' : 'white'}
                    _hover={{ borderColor: 'purple.300', bg: 'purple.50', transform: 'translateY(-2px)' }}
                    transition="all 0.2s"
                    onClick={() => setSectionForm(prev => ({ ...prev, type: 'quiz', isVideoUpload: false, content: "", transcript: "" }))}
                  >
                    <VStack spacing={2}>
                      <Icon as={FaBrain} w={6} h={6} color={sectionForm.type === 'quiz' ? 'purple.600' : 'gray.400'} />
                      <Text fontSize="sm" fontWeight="bold" color={sectionForm.type === 'quiz' ? 'purple.800' : 'gray.600'}>AI Quiz</Text>
                    </VStack>
                  </Box>
                </Grid>
              </FormControl>

              {sectionForm.type === "video" && (
                <Box p={5} bg="gray.50" borderRadius="2xl" border="1px dashed" borderColor="gray.300">
                  <FormControl isRequired mb={4}>
                    <FormLabel fontSize="sm" fontWeight="bold" color="gray.700">Video Source</FormLabel>
                    <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                      <Box 
                        as="button" p={3} borderRadius="lg" border="2px solid" 
                        borderColor={!sectionForm.isVideoUpload ? 'blue.400' : 'gray.200'} 
                        bg={!sectionForm.isVideoUpload ? 'blue.50' : 'white'}
                        _hover={{ borderColor: 'blue.300', bg: 'blue.50' }}
                        transition="all 0.2s"
                        onClick={() => setSectionForm(prev => ({ ...prev, isVideoUpload: false, content: "", transcript: "" }))}
                      >
                        <Text fontSize="sm" fontWeight="bold" color={!sectionForm.isVideoUpload ? 'blue.700' : 'gray.600'}>🔗 YouTube URL</Text>
                      </Box>
                      <Box 
                        as="button" p={3} borderRadius="lg" border="2px solid" 
                        borderColor={sectionForm.isVideoUpload ? 'blue.400' : 'gray.200'} 
                        bg={sectionForm.isVideoUpload ? 'blue.50' : 'white'}
                        _hover={{ borderColor: 'blue.300', bg: 'blue.50' }}
                        transition="all 0.2s"
                        onClick={() => setSectionForm(prev => ({ ...prev, isVideoUpload: true, content: "", transcript: "" }))}
                      >
                        <Text fontSize="sm" fontWeight="bold" color={sectionForm.isVideoUpload ? 'blue.700' : 'gray.600'}>📤 Upload File</Text>
                      </Box>
                    </Grid>
                  </FormControl>

                  {sectionForm.isVideoUpload ? (
                    <Box>
                      <FormControl isRequired>
                        <FormLabel fontSize="sm" fontWeight="bold">Upload Video File</FormLabel>
                        <HStack>
                          <Input
                            value={sectionForm.content}
                            placeholder="Upload path will appear here"
                            readOnly
                          />
                          <Box position="relative">
                            <Button colorScheme="purple" variant="solid" isLoading={isUploading}>
                              Browse
                            </Button>
                            <Input
                              type="file"
                              accept="video/*"
                              position="absolute"
                              top={0}
                              left={0}
                              w="full"
                              h="full"
                              opacity={0}
                              cursor="pointer"
                              onChange={handleFileUpload}
                              disabled={isUploading}
                            />
                          </Box>
                        </HStack>
                      </FormControl>
                      {isUploading && (
                        <HStack spacing={2} mt={2}>
                          <Spinner size="xs" color="purple.500" />
                          <Text fontSize="xs" color="purple.500" fontWeight="bold">AI is uploading & transcribing (OpenAI Whisper)...</Text>
                        </HStack>
                      )}
                    </Box>
                  ) : (
                    <FormControl isRequired>
                      <FormLabel fontSize="sm" fontWeight="bold">YouTube Video URL</FormLabel>
                      <Input
                        type="text"
                        name="content"
                        value={sectionForm.content}
                        onChange={handleSectionFormChange}
                        placeholder="Paste YouTube video link"
                      />
                    </FormControl>
                  )}

                  <FormControl mt={4}>
                    <FormLabel fontSize="sm" fontWeight="bold" color="gray.700">Video Transcript (Optional)</FormLabel>
                    <Textarea
                      name="transcript"
                      value={sectionForm.transcript}
                      onChange={handleSectionFormChange}
                      placeholder="Autogenerated transcript or custom text..."
                      rows={3}
                      _focus={{ borderColor: "purple.500", boxShadow: "0 0 0 1px purple.500" }}
                    />
                  </FormControl>
                </Box>
              )}

              {sectionForm.type === "documentation" && (
                <Box p={5} bg="gray.50" borderRadius="2xl" border="1px dashed" borderColor="gray.300">
                  <FormControl isRequired>
                    <FormLabel fontSize="sm" fontWeight="bold" color="gray.700">PDF Source Link</FormLabel>
                    <HStack>
                      <Input
                        type="text"
                        name="content"
                        value={sectionForm.content}
                        onChange={handleSectionFormChange}
                        placeholder="Paste PDF link or upload a file"
                        _focus={{ borderColor: "purple.500", boxShadow: "0 0 0 1px purple.500" }}
                      />
                      <Box position="relative">
                        <Button colorScheme="purple" variant="outline" isLoading={isUploading}>
                          Upload PDF
                        </Button>
                        <Input
                          type="file"
                          accept=".pdf"
                          position="absolute"
                          top={0}
                          left={0}
                          w="full"
                          h="full"
                          opacity={0}
                          cursor="pointer"
                          onChange={handleFileUpload}
                          disabled={isUploading}
                        />
                      </Box>
                    </HStack>
                  </FormControl>
                  {isUploading && (
                    <HStack spacing={2} mt={3}>
                      <Spinner size="xs" color="purple.500" />
                      <Text fontSize="xs" color="purple.500" fontWeight="bold">Uploading PDF document...</Text>
                    </HStack>
                  )}
                </Box>
              )}

              {sectionForm.type === "quiz" && (
                <Box p={5} bg="purple.50" borderRadius="2xl" border="1px solid" borderColor="purple.200" textAlign="center">
                  <Icon as={FaBrain} w={10} h={10} color="purple.500" mb={3} />
                  <Heading size="sm" color="purple.800" mb={2} className="dark-text-black">AI Quiz Generation Ready</Heading>
                  <Text color="purple.600" fontSize="sm" className="dark-text-black">
                    Once you save this module, AI will automatically read your previous lessons and generate a comprehensive quiz here.
                  </Text>
                </Box>
              )}
            </VStack>
          </ModalBody>

          <ModalFooter bg="gray.50" borderTop="1px solid" borderColor="gray.100">
            <Button variant="ghost" mr={3} onClick={onClose} borderRadius="xl">
              Cancel
            </Button>
            <Button colorScheme="purple" onClick={saveSection} isDisabled={isUploading} borderRadius="xl" size="lg" px={8} boxShadow="md">
              Save Module
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default EditPage;
  
